<template>
  <div class="en-m-header">
    <img @click="handleBack" src="@/assets/icon_back@3x.png" alt="back" v-if="isBack">
    <img @click="$emit('close', true)" src="@/assets/close.png" alt="back" v-else>
    <p>{{title}}</p>
    <span><slot name="right"></slot></span>
  </div>
</template>

<script>
export default {
  name: "OrderHeader",
  props: {
    title: {
      default: ''
    },
    isBack: {
      default: true
    }
  },
  methods: {
    handleBack(){
      if(this.$route.path != '/nightmarketcoupons') {
        this.$router.go(-1)
      } else {
         if (sessionStorage.getItem('fromPathNight')) {
           this.$router.push({path: sessionStorage.getItem('fromPathNight')})
         }else{
            this.$router.push('/en')
         }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.en-m-header {
  width: 100%;
  height: 44px;
  background-color: #EDEDED;
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  &>img:nth-of-type(1){
    width: 5vw;
    height: 4.5vw;
    position: relative;
    z-index: 8;
  }
  &>span {
    position: relative;
    z-index: 8;
    min-width: 9.33333vw;
    &>img{
      width: 8vw;
      height: 8vw;
    }
    &>span,&>span>a{
      font-size:4.26667vw;
      font-weight:500;
      color: #333;
    }
  }
  &>p {
    font-size:4.26667vw;
    font-weight:400;
    color:#333;
    line-height:6.66667vw;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 11.73333vw;
    padding: 0 21.33333vw;
  }
}
</style>